<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-4.88,798.78h1.79l2.13-2.07c0.89-0.9,3.58-0.9,4.48-1.79c0.89-0.9,1.14-1.98,0.89-3.59l-2.33,2.33l-2.31-0.38l-0.38-2.34
	l2.33-2.29c-1.82-0.23-2.69,0-3.59,0.89c-0.89,0.9-0.89,3.59-1.79,4.48l-3.58,3.59L-4.88,798.78z M0.5,782.5l-8.66,5v10l8.66,5
	l8.66-5v-10L0.5,782.5z M0.5,784.57l6.87,3.97v7.93l-6.87,3.96l-6.87-3.96v-7.93L0.5,784.57z"/>
</svg>

</template>